import { combineReducers } from 'redux';
import habitatInsightsUploadReducer from 'src/app/habitat-insights/state/habitatInsightsUploadSlice';
import addSiteToPlatformReducer from 'src/app/habitat-insights/state/addSiteToPlatformSlice';

export default combineReducers({
    habitatInsightsUpload: habitatInsightsUploadReducer,
    addSiteToPlatform: addSiteToPlatformReducer,
});
